import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=82771f78"
import script from "./AlertDialog.vue?vue&type=script&lang=ts"
export * from "./AlertDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports